import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 * smart suite agreement
 * @param { SmartsuiteAgreementKpi } data
 */
export function requestSmartsuiteAgreementKpi(params) {
  if (params === undefined) {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/getKpi`,
      {
        params: { limit: 100 },
      }
    );
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/getKpi?${params}`,
      {
        params: { limit: 100 },
      }
    );
  }
}
